export enum ProductLineEnums {
  PRODUCT_LINE_CUSTOM = 'Custom',
  PRODUCT_LINE_PRELUDE = 'Prelude',
  PRODUCT_LINE_INOVAE = 'Inovae',
  PRODUCT_LINE_REVOLAE = 'Revolae',
  PRODUCT_LINE_ICS = 'Curate',
  PRODUCT_LINE_INOVAE2O = 'Inovae 2.0',
}
